export default "__VITE_ASSET__CTTDixxj__";